import { render, staticRenderFns } from "./supervisorid.vue?vue&type=template&id=23920a96"
import script from "./supervisorid.vue?vue&type=script&lang=js"
export * from "./supervisorid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports